import react from 'react';



const Rank=({name,entries})=>{
// console.log("here is the format:"+entries);
return(

     <div><a className='no-underline' href='https://shivangbhardwaj.netlify.app/'>
     <div className='blue fw7 b '>{`This app is made by SHIVANG`}</div></a>
         <div className='white f3 fw6'>

         {` Hello ${name} ,your current Entry count is `}
         </div>

          <div className='white f1 fw7 '>
         {entries}
         </div>
     </div>

	);

}





export default Rank;